import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from "@mui/material";

const ContactDialog = ({ open,
  onConfirm,
  onCancel,
  loading = false,
  title = "Confirmar envio",
  message = "Deseja continuar com o envio da mensagem? Você pode cancelar esta ação.",
  confirmText = "Continuar",
  cancelText = "Cancelar",
}) => {
  return (
    <Dialog open={open} onClose={loading ? null : onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          size="large"
          onClick={onCancel}
          color="error"
          disabled={loading}
        >
          <strong>{cancelText}</strong>
        </Button>
        <Button
          size="large"
          onClick={onConfirm}
          variant="contained"
          sx={{ backgroundColor: '#121E1A', '&:hover': { backgroundColor: '#16a34a' } }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactDialog;